export const copyToClipboard = (value) => {
  const textarea = document.createElement('textarea');
  textarea.textContent = value;
  textarea.style.position = 'fixed';  // Prevent scrolling to bottom of page in MS Edge.
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return document.execCommand('copy');  // Security exception may be thrown by some browsers.
  } catch (ex) {
    console.warn('Copy to clipboard failed.', ex);
    return false;
  } finally {
    document.body.removeChild(textarea);
  }
};

export const pasteFromClipboard = async () => {
  if ((window as any).clipboardData) { // Edge
    return (window as any).clipboardData.getData('Text');
  }
  if ((navigator as any).clipboard) {
    if (typeof (navigator as any).clipboard.readText === 'function') {
      return await (navigator as any).clipboard.readText();
    }
    if (typeof (navigator as any).clipboard.read === 'function') {
      return await (navigator as any).clipboard.read();
    }
  }


  return ''; // :'(
};
